import { ref, provide } from 'vue'
import { colorBlend, hex2Rgba } from '../../../utils/index'
import { THEME_INJECTION_KEY } from '../../../tokens/index'

export function useStyleCssVars(defaultColor, otherStyleCallBack, user) {
  const colorPrimary = ref('#25b8b6') //记录默认主题色或环境配置主题色，用于在页面上自定义了主题色重置使用
  const primaryStyleVars = ref({
    '--color-primary': '#25b8b6',
    '--color-white': '#FFFFFF',
    '--color-black': '#000000',
    '--color-success': '#5ac800',
    '--color-warning': '#ff8c00',
    '--color-danger': '#ff1212',
    '--color-info': '#909399',
    '--pg--color-info': '#1e91ff',

    '--color-background-2': '#ff4f00',
    '--color-background-3': '#F4F5F7',

    '--color-text-primary': '#333333',
    '--color-text-primary-2': '#666666',
    '--color-text-primary-3': '#999999',

    '--border-color-base': '#DCDFE6',
    '--color-text-placeholder': '#C0C4CC',

    '--box-shadow-light': '0 2px 4px 0 rgba(37, 184, 182, .5)',

    '--font-size-base': '12px',
    '--font-size-2': '14px',
    '--font-size-3': '16px',
    '--font-size-4': '18px',
    ...defaultColor,
  })

  const otherStyle = (styles) => {
    // common
    const commix = {
      '--color-primary-light-05': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.05
      ),
      '--color-primary-light-1': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.1
      ),
      '--color-primary-light-15': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.15
      ),
      '--color-primary-light-2': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.2
      ),
      '--color-primary-light-25': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.25
      ),
      '--color-primary-light-3': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.3
      ),
      '--color-primary-light-4': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.4
      ),
      '--color-primary-light-5': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.5
      ),
      '--color-primary-light-6': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.6
      ),
      '--color-primary-light-7': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.7
      ),
      '--color-primary-light-8': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.8
      ),
      '--color-primary-light-9': colorBlend(
        styles['--color-white'],
        styles['--color-primary'],
        0.9
      ),
      '--color-primary-dark-1': colorBlend(styles['--color-black'], styles['--color-primary'], 0.1),
      '--color-primary-dark-25': colorBlend(
        styles['--color-black'],
        styles['--color-primary'],
        0.25
      ),
      '--color-primary-dark-2': colorBlend(styles['--color-black'], styles['--color-primary'], 0.2),
      '--color-primary-dark-3': colorBlend(styles['--color-black'], styles['--color-primary'], 0.3),
      '--color-primary-dark-4': colorBlend(styles['--color-black'], styles['--color-primary'], 0.4),
      '--color-primary-dark-5': colorBlend(styles['--color-black'], styles['--color-primary'], 0.5),
      '--color-primary-dark-6': colorBlend(styles['--color-black'], styles['--color-primary'], 0.6),
      '--color-primary-dark-7': colorBlend(styles['--color-black'], styles['--color-primary'], 0.7),
      '--color-primary-dark-8': colorBlend(styles['--color-black'], styles['--color-primary'], 0.8),
      '--color-primary-dark-9': colorBlend(styles['--color-black'], styles['--color-primary'], 0.9),
      '--color-opacity-white-8': hex2Rgba(styles['--color-white'], 0.8),
      '--color-opacity-white-3': hex2Rgba(styles['--color-white'], 0.3),
      '--color-opacity-primary-05': hex2Rgba(styles['--color-primary'], 0.05),
      '--color-opacity-primary-1': hex2Rgba(styles['--color-primary'], 0.1),
      '--color-opacity-primary-15': hex2Rgba(styles['--color-primary'], 0.15),
      '--color-opacity-primary-2': hex2Rgba(styles['--color-primary'], 0.2),
      '--color-opacity-primary-25': hex2Rgba(styles['--color-primary'], 0.25),
      '--color-opacity-primary-3': hex2Rgba(styles['--color-primary'], 0.3),
      '--color-opacity-primary-4': hex2Rgba(styles['--color-primary'], 0.4),
      '--color-opacity-primary-5': hex2Rgba(styles['--color-primary'], 0.5),
      '--color-opacity-primary-6': hex2Rgba(styles['--color-primary'], 0.6),
      '--color-opacity-primary-7': hex2Rgba(styles['--color-primary'], 0.7),
      '--color-opacity-primary-8': hex2Rgba(styles['--color-primary'], 0.8),
      '--color-opacity-primary-9': hex2Rgba(styles['--color-primary'], 0.9),
      '--color-danger-opacity-15': hex2Rgba(styles['--color-danger'], 0.15),

      '--color-info-opacity-15': hex2Rgba(styles['--color-info'], 0.15),
    }
    return {
      ...commix,
      '--button-color-primary': styles['--color-primary'],
      '--button-background-color-primary': styles['--color-primary'],
      '--pg-color-shadow-1': `0 -1px 4px 0 ${hex2Rgba(styles['--color-white'], 0.4)}`,
      //layout-main
      '--layout-header-font-color': styles['--color-white'],
      '--layout-header-background-color': styles['--color-primary'],
      '--layout-header-border-color': styles['--color-primary'],
      '--layout-header-organization-name-color': styles['--color-white'],
      '--layout-header-organization-date-color': styles['--color-white'],
      '--layout-baner-background-color': 'transparent',
      '--layout-baner-text-background-color': styles['--color-primary'],
      '--layout-baner-text-color': styles['--color-white'],
      '--layout-copyright-background-color': styles['--color-primary'],
      '--layout-copyright-font-color': hex2Rgba(styles['--color-white'], 0.7),
      '--layout-menu-item-hover-fill': colorBlend(
        styles['--color-white'],
        styles['--color-background-2'],
        0.4
      ),
      '--layout-menu-item-hover-fill-color': commix['--color-primary-dark-6'],
      '--layout-menu-font-color': commix['--color-primary-dark-6'],
      '--layout-menu-background-color': commix['--color-primary-light-2'],
      '--layout-menu-child-background-color': hex2Rgba(styles['--color-white'], 0.5),
      '--layout-menu-border-color': hex2Rgba(styles['--color-text-primary-3'], 0.2),
      '--layout-menu-search-list-background-color': hex2Rgba(styles['--color-white'], 0.9),
      '--layout-menu-search-list-hover-background-color': '#f3f3f3',
      '--layout-menu-search-color': '#C0C4CC',
      '--layout-menu-search-background-color': commix['--color-primary-dark-6'],
      '--layout-tag-background-color-left': commix['--color-primary-light-15'],
      '--layout-tag-background-color-right': commix['--color-primary-light-2'],
      '--layout-tab-border': commix['--color-primary-light-5'],
      '--layout-main-background-color': primaryStyleVars.value['--color-background-3'],
      //pg-table
      '--pg-table-background-color': styles['--color-white'],
      '--pg-table-header-background-color': commix['--color-primary-light-2'],
      '--pg-table-row-hover-background-color': commix['--color-primary-light-6'],
      '--pg-table-row-current-background-color': commix['--color-primary-light-2'],
      '--pg-table-row-checked-background-color': 'rgba(255, 161, 15, .15)',
      '--pg-table-stripe-background-color': '#f6f6f6',
      '--pg-table-border-color': primaryStyleVars.value['--border-color-base'],
      '--pg-table-header-text-color': primaryStyleVars.value['--color-text-primary'],
      '--pg-table-header-text-size': primaryStyleVars.value['--font-size-base'],

      //pgNotification
      '--pg-notification-shadow-success-color': hex2Rgba(styles['--color-success'], 0.5),
      '--pg-notification-tag-background-success-color': hex2Rgba(styles['--color-success'], 0.15),
      '--pg-notification-tag-border-success-color': hex2Rgba(styles['--color-success'], 0.2),
      '--pg-notification-shadow-warning-color': hex2Rgba(styles['--color-warning'], 0.5),
      '--pg-notification-tag-background-warning-color': hex2Rgba(styles['--color-warning'], 0.15),
      '--pg-notification-tag-border-warning-color': hex2Rgba(styles['--color-warning'], 0.2),
      '--pg-notification-shadow-danger-color': hex2Rgba(styles['--color-danger'], 0.5),
      '--pg-notification-tag-background-danger-color': hex2Rgba(styles['--color-danger'], 0.15),
      '--pg-notification-tag-border-danger-color': hex2Rgba(styles['--color-danger'], 0.2),
      '--pg-notification-shadow-info-color': hex2Rgba(styles['--pg--color-info'], 0.5),
      '--pg-notification-tag-background-info-color': hex2Rgba(styles['--pg--color-info'], 0.15),
      '--pg-notification-tag-border-info-color': hex2Rgba(styles['--pg--color-info'], 0.2),

      //pg-page-edit
      '--pg-page-edit-top-border-color': commix['--color-primary-light-3'],

      //pg-page-query
      '--pg-page-query-shortcut-background-color': commix['--color-primary-light-15'],
      '--pg-page-query-groups-background-color': commix['--color-primary-light-15'],
      '--pg-page-query-groups-border-color': commix['--color-primary-light-25'],
      '--pg-criteria-menus-front-item-color': commix['--color-primary-dark-6'],
      '--pg-page-query-page-background-color': styles['--color-white'],
      '--pg-page-query-page-font-color': styles['--color-text-primary'],
      '--pg-page-query-page-border-color': styles['--border-color-base'],
      '--pg-page-query-page-background-color2': styles['--color-white'],
      '--pg-page-query-page-shadow-color': 'transparent',
      //'drawer'
      '--drawer-background-color': primaryStyleVars.value['--color-background-3'],
      '--drawer-shadow':
        '0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 8%), 0 6px 30px 5px rgb(0 0 0 / 12%)',
      ...styles,
      ...otherStyleCallBack?.(commix, primaryStyleVars),
    }
  }

  const setCssVarMethod = (custorm) => {
    const styleVars = otherStyle(Object.assign({}, primaryStyleVars.value, custorm))
    const root = document.querySelector(':root')
    Object.keys(styleVars).forEach((key) => {
      root.style.setProperty(key, styleVars[key])
    })
  }

  //获取自定义主题的key
  const getCustormThemeKey = () => {
    if (user.value?.CurrentTicket?.member?.id && user.value?.CurrentTicket?.system?.code) {
      return `THEME-${user.value.CurrentTicket.system.code}-${user.value.CurrentTicket.member.id}-${window.location.host}`
    } else {
      return null
    }
  }

  provide(THEME_INJECTION_KEY, {
    colorPrimary,
    primaryStyleVars,
    setCustormCssVar(custorm) {
      if (custorm['--color-primary']) {
        primaryStyleVars.value['--color-primary'] = custorm['--color-primary']
      }
      if (primaryStyleVars.value['--color-primary'] === colorPrimary.value) {
        localStorage.removeItem(getCustormThemeKey())
      } else {
        localStorage.setItem(getCustormThemeKey(), JSON.stringify(custorm))
      }
      setCssVarMethod(custorm)
    },
    getCustormThemeKey,
  })

  const setCssVar = () => {
    colorPrimary.value = primaryStyleVars.value['--color-primary']
    const historyTheme = localStorage.getItem(getCustormThemeKey())
    const historyThemeCustorm = historyTheme ? JSON.parse(historyTheme) : null
    if (historyThemeCustorm?.['--color-primary']) {
      primaryStyleVars.value['--color-primary'] = historyThemeCustorm['--color-primary']
    }
    setCssVarMethod(historyThemeCustorm)
  }

  return {
    primaryStyleVars,
    setCssVar,
  }
}
